import { Injectable } from '@angular/core';
import { AppDataService } from './app-data.service';
import { BehaviorSubject } from 'rxjs';
import { PushNotificationService } from './push-notifications.service';
import { Capacitor } from '@capacitor/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class SideMenuService {
  public appPages = new BehaviorSubject([]);
  public selectedIndex = 0;
  currentLoggedInUserRole = '';
  homePageUrl = '';
  currentLangKey = 'bg';
  public languageList = new BehaviorSubject([]);;
  constructor(
    private dataService: AppDataService,
    private pushNotificationService: PushNotificationService,
    private storage: Storage,
  ) {
    // this.storage.get('system_language_key').then(langKey => {
    //  this.currentLangKey = langKey ?? 'bg';
    // });
    this.currentLangKey = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'bg';
  }

  async initSideMenu() {
    const tempSideMenu: any = await this.dataService.getData('slideout_menu');

    var sideMenuData = [];

    this.setLanguageListData();

    // console.log('Temp Side Menu Data', tempSideMenu);

    tempSideMenu.data.map((sd) => {
      const tempSideMenuData = JSON.parse(JSON.stringify(sd));
      const tempObj = {
        ['title']: this.getCurrentLanguageTilet(tempSideMenuData?.translations) ? this.getCurrentLanguageTilet(tempSideMenuData?.translations) : tempSideMenuData?.translations[0] ? tempSideMenuData?.translations[0].title : '',
        ['url']: tempSideMenuData.path
          ? tempSideMenuData.path
          : tempSideMenuData.module?.default_path,
        ['icon']: tempSideMenuData.icon,
        ['image_icon']: tempSideMenuData.image_icon?.data?.full_url,
        ['uid']: tempSideMenuData.module?.uid,
        ['collections']: tempSideMenuData.module?.collections,
        ['require_login']: tempSideMenuData.require_login,
        ['require_role']: tempSideMenuData.require_role,
        ['visible']: tempSideMenuData.visible,
        ['is_home_page']: tempSideMenuData.is_home_page,
        ['sort']: tempSideMenuData.sort,
        ['background_color']: tempSideMenuData.background_color,
        ['title_color']: tempSideMenuData.title_color,
        ['icon_color']: tempSideMenuData.icon_color,
        ['layouts']: tempSideMenuData.module?.layouts,
        ['www_url']: tempSideMenuData.www_url,
        ['layout']: tempSideMenuData.module?.settings
          ? tempSideMenuData.module.settings.layout
          : '',
      };
      sideMenuData.push(tempObj);
    });
    let userType = await this.storage.get('userType')
    if (userType != "Driver" && userType != "Admin") {
      sideMenuData.forEach((obj: any, index) => {
        if (obj.url == "my-courses") {
          sideMenuData.splice(index, 1)
          return
        }
      })
    } else if (userType == "Driver") {
      sideMenuData = sideMenuData.filter((obj: any) => {
        return obj.url == "my-courses" || obj.url == "notifications"
      })
    }
    // console.log('sideMenuData', sideMenuData, await this.storage.get('userType'));
    // this.appPages.next([...tempSideMenu.data]);
    this.appPages.next([...sideMenuData]);
    // const sortedSideMenu: any = tempSideMenu.data.sort(
    //   (a: any, b: any) => a.order - b.order
    // )[0];

    // Init Push Notfications
    const isPushNotificationAvailable = Capacitor.isPluginAvailable(
      'PushNotifications'
    );
    // console.log('Is Push Notification Avaialble', isPushNotificationAvailable);
    if (isPushNotificationAvailable) {
      this.pushNotificationService.initPushNotification('');
    }

    // Init System Languages Data
    const systemLanguageSnap = await this.dataService.getSystemLanguagesData(
      'system_languages'
    );

    // return sortedSideMenu?.url;
    // check if there is home page in System setting collection if yes then send it
    // otherwise send first url
    this.homePageUrl !== ''
      ? this.setHomePageUrlAndSelectedIndex(sideMenuData)
      : sideMenuData[0]?.url;
    // return sideMenuData[0]?.url;
  }

  getCurrentLanguageTilet(data) {
    var title = data.find((i) => i.language == this.currentLangKey);
    return title ? title.title : null
  }

  setHomePageUrlAndSelectedIndex(sideMenuData) {
    const homePage = sideMenuData.find((menu) => menu.url === this.homePageUrl);
    const homePageIndex = sideMenuData.indexOf(homePage);
    // Check if there is homePageIndex, if yes set it otherwise set default.
    this.selectedIndex = homePageIndex >= 0 ? homePageIndex : 0;
    return this.homePageUrl;
  }

  getdatabaseCollectoin(id) {
    const temp = this.findSelectedSidemenu(id);
    return temp?.collections;
  }

  getLayoutsCollection(id) {
    const temp = this.findSelectedSidemenu(id);
    return temp?.layouts ?? [];
  }

  getLayoutFromDatabase(id) {
    const temp = this.findSelectedSidemenu(id);
    return temp.layout;
  }
  findSelectedSidemenu(id) {
    return this.appPages.getValue().find((obj) => obj.uid === id);
  }

  findHomeMenu() {
    var lst = []
    this.appPages.getValue().forEach(element => {
      if (element.is_home_page) {
        lst.push(element)
      }
    });
    return lst;
  }

  async setLanguageListData() {
    const systemLanguageData: any = await this.dataService.getData(
      'system_languages'
    );
    this.languageList.next([...systemLanguageData.data]);
  }

  setCurrentAppLanguage(langKey: string) {
    localStorage.setItem('lang', langKey)
    this.currentLangKey = langKey;
    this.storage.set('system_language_key', langKey);
  }
}
